import React, { useState, useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";

const Navbar = ({ onNavigate }) => {
  const location = useLocation();
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200);

  // Handle resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1200);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Reset dropdowns on route change
  useEffect(() => {
    setActiveDropdown(null);
    setActiveSubmenu(null);
  }, [location]);

  // Outside click close
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".dropdown")) {
        setActiveDropdown(null);
        setActiveSubmenu(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // Toggle for click-based dropdown (mobile)
  const toggleDropdown = (menu, e) => {
    e.preventDefault();
    setActiveDropdown(activeDropdown === menu ? null : menu);
  };

  const toggleSubmenu = (submenu, e) => {
    e.preventDefault();
    setActiveSubmenu(activeSubmenu === submenu ? null : submenu);
  };

  const closeMobileMenu = () => {
    setActiveDropdown(null);
    setActiveSubmenu(null);

    if (isMobile && onNavigate) {
      onNavigate();
    }
  };

  return (
    <>
      <div className="nav-item">
        <NavLink className={`nav-link ${location.pathname === "/" ? "active" : ""}`} to="/" onClick={closeMobileMenu}>
          Home
        </NavLink>
      </div>

      <div className="nav-item">
        <NavLink className={`nav-link ${location.pathname === "/about" ? "active" : ""}`} to="/about" onClick={closeMobileMenu}>
          About Us
        </NavLink>
      </div>

      {/* Services Dropdown */}
      <div
        className="nav-item dropdown"
        onMouseEnter={() => !isMobile && setActiveDropdown("services")}
        onMouseLeave={() => !isMobile && setActiveDropdown(null)}
      >
        <NavLink
          className={`nav-link dropdown-toggle ${location.pathname.startsWith("/services") ? "active" : ""}`}
          to="/services"
          onClick={(e) => isMobile && toggleDropdown("services", e)}
        >
          Services
        </NavLink>

        <ul className={`dropdown-menu ${activeDropdown === "services" ? "show" : ""}`}>
          <li>
            <NavLink
              className={`dropdown-item ${location.pathname === "/infrastructure" ? "active" : ""}`}
              to="/infrastructure"
              onClick={closeMobileMenu}
            >
              Infrastructure Solutions
            </NavLink>
          </li>

           <li>
            <NavLink
              className={`dropdown-item ${location.pathname === "/business" ? "active" : ""}`}
              to="/business"
              onClick={closeMobileMenu}
            >
              Business Analytics
            </NavLink>
          </li>

          {/* SAP & ERP Solutions Submenu */}
          <li
            className="dropdown-submenu"
            onMouseEnter={() => !isMobile && setActiveSubmenu("sap-erp")}
            onMouseLeave={() => !isMobile && setActiveSubmenu(null)}
          >
            <NavLink
              className={`dropdown-item has-arrow ${
                location.pathname === "/erp" || location.pathname === "/erp" ? "active" : ""
              }`}
              to="#"
              onClick={(e) => isMobile && toggleSubmenu("sap-erp", e)}
            >
               ERP Solutions
            </NavLink>
            <ul className={`dropdown-menu sub-menu ${activeSubmenu === "sap-erp" ? "show" : ""}`}>
              <li>
                <NavLink
                  className={`dropdown-item ${location.pathname === "/sap" ? "active" : ""}`}
                  to="/sap"
                  onClick={closeMobileMenu}
                >
                  SAP Solutions
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={`dropdown-item ${location.pathname === "/oraclesolutions" ? "active" : ""}`}
                  to="/oraclesolutions"
                  onClick={closeMobileMenu}
                >
                  Oracle Solutions
                </NavLink>
              </li>
            </ul>
          </li>



{/* 
           <li
            className="dropdown-submenu"
            onMouseEnter={() => !isMobile && setActiveSubmenu("sap-erp")}
            onMouseLeave={() => !isMobile && setActiveSubmenu(null)}
          >
            <NavLink
              className={`dropdown-item has-arrow ${
                location.pathname === "/cyber" || location.pathname === "/cyber" ? "active" : ""
              }`}
              to="/cyber"
              onClick={(e) => isMobile && toggleSubmenu("sap-erp", e)}
            >
               Cybersecurity
            </NavLink>
            <ul className={`dropdown-menu sub-menu ${activeSubmenu === "sap-erp" ? "show" : ""}`}>
              <li>
                <NavLink
                  className={`dropdown-item ${location.pathname === "/soc2" ? "active" : ""}`}
                  to="/soc2"
                  onClick={closeMobileMenu}
                >
                  SOC2/ISO 27001 Compliance
                </NavLink>
              </li>
             
            </ul>
          </li> */}







          <li>
            <NavLink
              className={`dropdown-item ${location.pathname === "/cyber" ? "active" : ""}`}
              to="/cyber"
              onClick={closeMobileMenu}
            >
              Cybersecurity
            </NavLink>
          </li>
          <li>
            <NavLink
              className={`dropdown-item ${location.pathname === "/micro" ? "active" : ""}`}
              to="/micro"
              onClick={closeMobileMenu}
            >
              Microservices
            </NavLink>
          </li>

           <li>
            <NavLink
              className={`dropdown-item ${location.pathname === "/Soc2" ? "active" : ""}`}
              to="/Soc2"
              onClick={closeMobileMenu}
            >
              

             SOC 2/ISO 27001 Compliance
            </NavLink>
          </li>
          <li>
            <NavLink
              className={`dropdown-item ${location.pathname === "/it" ? "active" : ""}`}
              to="/it"
              onClick={closeMobileMenu}
            >
              

              IT Staffing
            </NavLink>
          </li>
        </ul>
      </div>

      {/* Solutions Dropdown */}
      <div
        className="nav-item dropdown"
        onMouseEnter={() => !isMobile && setActiveDropdown("solutions")}
        onMouseLeave={() => !isMobile && setActiveDropdown(null)}
      >
        <NavLink
          className={`nav-link dropdown-toggle ${location.pathname.startsWith("/solutions") ? "active" : ""}`}
          to="solutions"
          onClick={(e) => isMobile && toggleDropdown("solutions", e)}
        >
          Solutions
        </NavLink>

        <ul className={`dropdown-menu ${activeDropdown === "solutions" ? "show" : ""}`}>
          <li>
            <NavLink
              className={`dropdown-item ${location.pathname === "/managed-services" ? "active" : ""}`}
              to="/managed-services"
              onClick={closeMobileMenu}
            >
              Managed Services
            </NavLink>
          </li>

          <li>
            <NavLink
              className={`dropdown-item ${location.pathname === "/DataCenters" ? "active" : ""}`}
              to="/DataCenters"
              onClick={closeMobileMenu}
            >
              Data Center Solutions
            </NavLink>
          </li>

          <li>
            <NavLink
              className={`dropdown-item ${location.pathname === "/Private5G" ? "active" : ""}`}
              to="/Private5G"
              onClick={closeMobileMenu}
            >
              Private5G Solutions
            </NavLink>
          </li>
          <li>
            <NavLink
              className={`dropdown-item ${location.pathname === "/IndustrialAR" ? "active" : ""}`}
              to="/IndustrialAR"
              onClick={closeMobileMenu}
            >
              Industrial AR Solutions
            </NavLink>
          </li>
          <li>
            <NavLink
              className={`dropdown-item ${location.pathname === "/SmartSurveillance" ? "active" : ""}`}
              to="/SmartSurveillance"
              onClick={closeMobileMenu}
            >
              Smart Surveillance Solutions
            </NavLink>
          </li>





          <li>
            <NavLink
              className={`dropdown-item ${location.pathname === "/case-studies" ? "active" : ""}`}
              to="/case-studies"
              onClick={closeMobileMenu}
            >
              Case Studies
            </NavLink>
          </li>

          
        </ul>
      </div>

      <div className="nav-item">
        <NavLink className={`nav-link ${location.pathname === "/careers" ? "active" : ""}`} to="/careers" onClick={closeMobileMenu}>
          Careers
        </NavLink>
      </div>

      <div className="nav-item">
        <NavLink className={`nav-link ${location.pathname === "/contact" ? "active" : ""}`} to="/contact" onClick={closeMobileMenu}>
          Contact Us
        </NavLink>
      </div>

      {/* <div className="nav-item">
        <NavLink className={`nav-link ${location.pathname === "/Others" ? "active" : ""}`} to="/Others">
          Others
        </NavLink>
      </div> */}
    </>
  );
};

export default Navbar;
